import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationPackage } from 'src/app/enums/application-package.enum';
import { environment } from 'src/environments/environment';
import { Service } from 'src/app/enums/service.enum';
import { ContentLanguage } from 'src/app/model/cms-vod-core/content-language.model';

@Injectable({
    providedIn: 'root',
})
export class ContentLanguageService {
    readonly contentLanguageApiUrl = environment.endPoint + ApplicationPackage.CMS_VOD + Service.CONTENT_LANG;

    constructor(private http: HttpClient) { }

    getAllContentLanguage(): Observable<ContentLanguage[]> {
        return this.http.get<ContentLanguage[]>(this.contentLanguageApiUrl);
    }

    getAllActiveContentLanguage(): Observable<ContentLanguage[]> {
        return this.http.get<ContentLanguage[]>(this.contentLanguageApiUrl + "/active");
    }

    getContentLanguageById(contentLanguageId: number): Observable<ContentLanguage> {
        return this.http.get<ContentLanguage>(this.contentLanguageApiUrl + `/${contentLanguageId}`);
    }

    addContentLanguage(contentLanguage: ContentLanguage): Observable<ContentLanguage> {
        return this.http.post<ContentLanguage>(this.contentLanguageApiUrl, contentLanguage);
    }

    editContentLanguage(contentLanguageId: number, contentLanguage: ContentLanguage): Observable<ContentLanguage> {
        return this.http.put<ContentLanguage>(this.contentLanguageApiUrl + `/${contentLanguageId}`, contentLanguage);
    }

    updateContentLanguageStatus(contentLanguageId: number, status: boolean): Observable<ContentLanguage> {
        return this.http.patch<ContentLanguage>(this.contentLanguageApiUrl + `/${contentLanguageId}/status?status=${status}`, {});
    }

    deleteContentLanguage(id: number): Observable<any> {
        return this.http.delete(this.contentLanguageApiUrl + `/${id}`);
    }
}